import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles'

import { AppBar, Toolbar, CssBaseline, List, ListItem, ListItemText, IconButton, Typography, Grid, Divider, Button, Box, Card, CardActions, CardContent } from "@material-ui/core";

// import MenuIcon from '@material-ui/icons/Menu';
// import ClearIcon from '@material-ui/icons/Clear';
import PersonIcon from '@material-ui/icons/Person';

import { DialogCompanyApproval, DialogConfirm } from './Dialog';

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';

import { Link, useHistory } from 'react-router-dom'

import { COLORS } from './Theme'
import { SIcon } from './Icon';

import axios from 'axios';

import { member as v_member, basic, Values, SNACKBAR_TIME } from '../request/values';
import { TitleBackBar } from './header/TitleBar';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    paper: {
        // marginTop: theme.spacing(8),
        marginTop: '3vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },


    toolBar: {
        // padding: theme.spacing(1),
        // paddingTop: theme.spacing(2),
        // paddingLeft: theme.spacing(4),
        // paddingRight: theme.spacing(4),
    },
    button: {
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
    },
    back: {
        float: 'left',
        width: '20%',
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        float: 'left',
        textAlign: 'center',
        width: '66.6666666%',
    },


    title: {
        fontSize: 30,
        color: `${COLORS.WATER_BLUE}`,
        // marginBottom: '0.5vh',
        // alignItems: 'center',
        // flexGrow: 1,
        // textAlign: 'center',
    },

    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),

    },
    appList: {
        backgroundColor: `${COLORS.LIGHT_GREY}`,
        padding: '14px 28px',
        [theme.breakpoints.up("md")]: {
          backgroundColor: `${COLORS.LIGHT_GREY}`,
          padding: '22px 28px',
      },
    },
    edit_button: {
        height: 'auto',
        borderRadius: '5px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.WHITE}`,
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        padding: '1vw',
        ...theme.typography.body1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        width: 'auto',
    },
    buttonLabel: {
        color: `${COLORS.CHARCHOAL_GREY}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
    },
    buttonLabel1: {
        color: `${COLORS.BROWNISH_GREY}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
        padding: 0,
    },
    buttonLabel2: {
        color: `${COLORS.WATER_BLUE}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
        padding: 0,
    },
    submit: {
        height: 60,
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
    },

}));

type iAppList = {
    application_date: string,
    member_email: string,
    member_name: string,
    member_phone: string,
}

const CompanyAppList: React.FC<any> = props => {

    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const { member } = props;
    const history = useHistory()

    const [appList, setAppList] = useState<iAppList[]>([])
    const [approvalDialog, setApprovalDialog] = useState<boolean | number>(false)
    const [declineDialog, setDeclineDialog] = useState<boolean | number>(false)

    const handleClose = (key: string) => {
        if (key === 'approvalDialog')
            setApprovalDialog(prevState => false);
        else if (key === 'declineDialog') {
            setDeclineDialog(prevState => false);
        }
    };

    const handleApprovalOpen = (index: number) => {
        console.log('open', index)
        if (approvalDialog === false) {
            setApprovalDialog(prevState => index);
        }
    }

    const handleDeclineOpen = (index: number) => {
        console.log('open', index)
        if (declineDialog === false) {
            setDeclineDialog(prevState => index);
        }
    }

    const getAppList = () => {
        let url = new URL(basic.server + v_member.member + v_member.company_app_list);
        let params = { 'companyNum': member.companyNum, 'classCode': member.classCode }
        url.search = new URLSearchParams(params).toString();

        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString(),
        }).then((res) => res.data).then((data) => {
            console.log(data);
            setAppList(data.appList)
        })
    }

    const action = (key: any) => (
        <Fragment>
            <Button onClick={() => { closeSnackbar(key) }}>
                Close
            </Button>
        </Fragment>
    );

    const postUserCompanyUpdate = (index: number) => {
        axios({
            method: "POST",
            data: {
                email: appList[index].member_email,
                companyNum: member.companyNum,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.company_approval,
        }).then((res) => {
            return res.data
        }).then((data: any) => {
            console.log(data)
            if (data.code === Values.SUCCESS_CODE) {
                enqueueSnackbar(ToastStr.COMPANY_APPROVAL_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                getAppList()
            } else if (data.code === Values.FAIL_CODE) {
                enqueueSnackbar(ToastStr.COMPANY_APPROVAL_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
            } else {
                enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })
            }
        })
    }

    const postCompanyAppDelete = () => {
        if (declineDialog !== false) {
            axios({
                method: "POST",
                data: {
                    email: appList[declineDialog as number].member_email,
                    companyNum: member.companyNum,
                },
                withCredentials: true,
                url: SERVER + v_member.member + v_member.company_decline,
            }).then((res) => {
                return res.data
            }).then((data: any) => {
                console.log(data)
                if (data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_DECLINE_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    getAppList()
                } else if (data.code === Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_DECLINE_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                }
            })
        }
        handleClose('declineDialog')
    }

    /*const postCompanyAppDelete = () => {
        axios({
            method: "POST",
            data: {
                companyNum: parseInt(radio),
                email: member.id,
            },
            withCredentials: true,
            url: SERVER + v_member.member + v_member.company_app,
        }).then((res) => { return res.data })
            .then((data: any) => {
                console.log(data)
                if (data.code == Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_APP_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME })
                    // setMember(...member, {companyNum : -1})
                    // setMember((prevState:any) => ...prevState, {companyNum : -1})

                    console.log(Object.assign({}, member, { companyNum: -1 }))
                    setMember(Object.assign({}, member, { companyNum: -1 }))

                    history.push({
                        pathname: '/CompanyAppStandBy',
                    });
                } else {
                    if (data.code == Values.FAIL_CODE) {
                        enqueueSnackbar(ToastStr.COMPANY_APP_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
                    } else {
                        enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME })
                    }
                }
            })
        handleClose()
    }*/

    const refusal = () => {
        postCompanyAppDelete()
        handleClose('declineDialog')
    }

    useEffect(() => {
        getAppList()
    }, [])

    const moveEditMember = () => {
        history.push({
            pathname: '/CompanyEditMember'
        })
    }

    return (
        <div className='content'>
            <TitleBackBar history={history} title="지원자 목록" titleIcon="profile_green" />
            <div style={{ textAlign: 'right', marginLeft: 'auto', paddingBottom: '1vh', paddingRight: '6vw'}}>
                <Button className = {classes.edit_button} onClick = {moveEditMember}>팀원 수정하기</Button>
            </div>
            <div className={classes.paper}>
                <List className={classes.form} >
                    {appList != null && appList.map((item: any, index: number) => {
                        return <AppListItem name={item.member_name} approval={() => postUserCompanyUpdate(index)} refusal={() => handleDeclineOpen(index)} />
                    })}
                </List>
                <div style={{ height: '10vh' }}></div>
            </div>
            <DialogConfirm
                open={declineDialog === false ? false : true}
                handleClose={() => handleClose('declineDialog')}
                title={"입사를 거절하시겠습니까?"}
                memberName={declineDialog === false ? '' : appList[declineDialog as number].member_name}
                yesConfirm={refusal}
                noConfirm={() => handleClose('declineDialog')}
            />
            <DialogCompanyApproval
                open={approvalDialog === false ? false : true}
                handleClose={() =>handleClose('approvalDialog')}
                memberName={approvalDialog === false ? '' : appList[approvalDialog as number].member_name}
                companyType={member.companyType}
                noConfirm={() =>handleClose('approvalDialog')}
                yesConfirm={postUserCompanyUpdate}
            />
        </div>
    )
}

const AppListItem: React.FC<any> = props => {

    const classes = useStyles();
    const { name, refusal, approval } = props

    return (
        <ListItem className={classes.appList}>
            <Box flexGrow={1} className={classes.buttonLabel}>{name}</Box>
            <Box><Button onClick={refusal} className={classes.buttonLabel1}>거절</Button></Box>
            <Box><Button onClick={approval} className={classes.buttonLabel2}>승인</Button></Box>
        </ListItem>
    )
}

export default CompanyAppList;